var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-the-j05-chat-screen"},[(_vm.chatLog)?_c('div',{staticClass:"p-the-j05-chat-screen__chat"},_vm._l((_vm.chatLog),function(ref,key){
      var id = ref.id;
      var name = ref.name;
      var icon = ref.icon;
      var date = ref.date;
      var time = ref.time;
      var message = ref.message;
      var title = ref.title;
      var unread = ref.unread;
      var isYouSent = ref.isYouSent;
return _c('div',{key:key,staticClass:"p-the-j05-chat-screen__chat__item"},[_c('J05ChatScreenPanel',{attrs:{"chat-data":{
          chatLog: _vm.chatLog,
          id: id,
          name: name,
          icon: icon,
          date: date,
          time: time,
          message: message,
          title: title,
          unread: unread,
          key: key,
          isYouSent: isYouSent
        },"unread-key-no":_vm.unreadKeyNo}})],1)}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }